<template>
  <div class="home">
    <RomaHome></RomaHome>
  </div>
</template>

<script>
import RomaHome from "@/components/poll/RomaHome";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Home",
  components: {
    RomaHome,
  },
  mounted() {
    // console.log(this.$route);
    // check in HOME 
    if( Object.keys(this.$route.query).length === 0 ){
      console.log("check in HOME if there is no querys params ");
    }else{
    const i =
      typeof this.$route.query.i === "undefined" || this.$route.query.i === ""
        ? null
        : this.$route.query.i;

        if (i !== null) {
          console.log(i, this.information.idInstitucion)
          if(i != this.information.institutionId) {
            this.reset();
            this.getInformation(i);
            this.notFound(false);
          } else {
            this.notFound(false);
          }
        }
        else {
          this.reset();
          this.notFound(true);
        this.$router.push({
          name: 'not-found'
          });
        }
    }
  },
  computed: {
    ...mapGetters({
      information: "getInformation"
    }),
  },
  methods: {
    ...mapActions({
      setInformation: "setInformation",
      searchPoll: "searchPoll",
      toastError: "toastError",
      notFound: "setNotFound",
      reset: "reset"
    }),
    async getInformation(i) {
      await this.setInformation({ idInstitucion: i })
        .then((response) => {
          if (typeof response === "undefined") {
            this.notFound(true);
            this.$router.push({ name: 'not-found' });
          }
        })
        .catch((error) => {
          console.info(error);
        });
    },
  },
};
</script>
<style lang="scss">
.home {
  height: 100%;
  display: flex;
  // align-items: center;
}
</style>
